import { configureStore } from "@reduxjs/toolkit";
import companyReducer from "./companyReducer";
import cartReducer from "./shoppingCartReducer";
import userReducer from "./userReducer";

export default configureStore({
    reducer:
    {
        cart: cartReducer,
        company: companyReducer,
        user:userReducer  
    },

});